/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum InvestitionType {
    Ware = 'Ware',
    Einrichtung = 'Einrichtung',
    Gebaeude = 'Gebaeude'
  }

    export const InvestitionTypeTranslocoMap: Record<InvestitionType, string> = {
    [InvestitionType.Ware]: 'investitionType.ware',
    [InvestitionType.Einrichtung]: 'investitionType.einrichtung',
    [InvestitionType.Gebaeude]: 'investitionType.gebaeude',
    };

    export const InvestitionTypeOptions = [
  { value: InvestitionType.Ware, labelKey: 'investitionType.ware' },
  { value: InvestitionType.Einrichtung, labelKey: 'investitionType.einrichtung' },
  { value: InvestitionType.Gebaeude, labelKey: 'investitionType.gebaeude' },
    ];

